<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div
        class="absolute inset-0 z-10 overflow-hidden bg-zinc-200/40 dark:bg-zinc-900/60 backdrop-blur-md flex items-center justify-center">


        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">

            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <!-- Header -->
            <div
                class="shrink-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
                <div class="flex items-center">
                    <div class="shrink-0">
                        <div
                            class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path
                                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                            </svg>
                        </div>
                    </div>
                    <div class="ml-4">
                        <h3 id="contact-support-modal-title"
                            class="text-base font-semibold text-gray-900 dark:text-white">Rate & Review</h3>
                        <p class="text-sm text-gray-500 dark:text-gray-400">
                            Leave ratings and a review for {{ creator()?.firstName }}.
                        </p>
                    </div>
                </div>
            </div>
            <!-- Header - END -->

            <!-- Main Content -->
            <div class="z-10 flex-1 mx-auto w-4xl flex flex-col overflow-y-auto gap-y-6 scrollbar-transparent px-2">

                <div class="card-container-pale rounded-xl px-4">
                    <ul role="list" class="divide-y divide-gray-100 dark:divide-white/5">
                        <!-- Work Quality -->
                        <li class="flex justify-between gap-x-6 py-2">
                            <div class="flex min-w-0 gap-x-4">
                                <div class="min-w-0 flex-auto">
                                    <p class="text-sm/6 font-semibold text-primary">Work Quality</p>
                                    <p class="mt-1 truncate text-xs/5 text-secondary">
                                        Did the deliverables meet the brief and your bar?</p>
                                </div>
                            </div>

                            <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                <vs-star-rating [rating]="5" [updatable]="true" [starSize]="8"
                                    (newRating)="updateRating($event, 'workQuality')" [updatable]="!isSubmittingReview()"></vs-star-rating>
                                <p class="text-xs/5 text-secondary">Tap to rate</p>
                            </div>
                        </li>

                        <!-- Communication -->
                        <li class="flex justify-between gap-x-6 py-2">
                            <div class="flex min-w-0 gap-x-4">
                                <div class="min-w-0 flex-auto">
                                    <p class="text-sm/6 font-semibold text-primary">Communication</p>
                                    <p class="mt-1 truncate text-xs/5 text-secondary">
                                        Clear, responsive, easy to collaborate with?</p>
                                </div>
                            </div>

                            <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                <vs-star-rating [rating]="5" [updatable]="true" [starSize]="8"
                                    (newRating)="updateRating($event, 'communication')" [updatable]="!isSubmittingReview()"></vs-star-rating>
                                <p class="text-xs/5 text-secondary">Tap to rate</p>
                            </div>
                        </li>

                        <!-- Professionalism -->
                        <li class="flex justify-between gap-x-6 py-2">
                            <div class="flex min-w-0 gap-x-4">
                                <div class="min-w-0 flex-auto">
                                    <p class="text-sm/6 font-semibold text-primary">Professionalism</p>
                                    <p class="mt-1 truncate text-xs/5 text-secondary">
                                        Followed the contract, brand and tone?</p>
                                </div>
                            </div>

                            <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                <vs-star-rating [rating]="5" [updatable]="true" [starSize]="8"
                                    (newRating)="updateRating($event, 'professionalism')" [updatable]="!isSubmittingReview()"></vs-star-rating>
                                <p class="text-xs/5 text-secondary">Tap to rate</p>
                            </div>
                        </li>

                        <!-- Time management -->
                        <li class="flex justify-between gap-x-6 py-2">
                            <div class="flex min-w-0 gap-x-4">
                                <div class="min-w-0 flex-auto">
                                    <p class="text-sm/6 font-semibold text-primary">Time Management</p>
                                    <p class="mt-1 truncate text-xs/5 text-secondary">
                                        Hit deadlines and milestones?</p>
                                </div>
                            </div>

                            <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                <vs-star-rating [rating]="5" [updatable]="true" [starSize]="8"
                                    (newRating)="updateRating($event, 'timeManagement')" [updatable]="!isSubmittingReview()"></vs-star-rating>
                                <p class="text-xs/5 text-secondary">Tap to rate</p>
                            </div>
                        </li>
                    </ul>
                </div>


                <!-- Would Recommend -->
                <div class="card-container-pale rounded-xl p-4">
                    <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                        <div class="">
                            <h3 class="text-base font-semibold text-primary">Would you recommend {{ creator()?.firstName
                                }}?</h3>
                            <p class="mt-1 text-sm text-secondary">Helps creators we trust surface for similar briefs.
                            </p>
                        </div>
                        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
                            <div class="border border-primary rounded-full p-1 flex flex-row items-center gap-x-2">
                                <button type="button" (click)="setWouldRecommend(false)" [disabled]="isSubmittingReview()"
                                    class="w-24 inline-flex items-center justify-center gap-x-2 rounded-full px-2.5 py-1.5 text-sm font-semibold shadow-xs"
                                    [class]="noReccomendClass()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="-ml-0.5 size-5">
                                        <path
                                            d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                                        <path d="M17 14V2" />
                                    </svg>
                                    No
                                </button>

                                <button type="button" (click)="setWouldRecommend(true)" [disabled]="isSubmittingReview()"
                                    class="w-24 inline-flex items-center justify-center gap-x-2 rounded-full px-2.5 py-1.5 text-sm font-semibold shadow-xs"
                                    [class]="yesReccomendClass()">
                                    Yes
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="-mr-0.5 size-5">
                                        <path
                                            d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                                        <path d="M7 10v12" />
                                    </svg>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- Would Recommend - END -->


                <!-- Comment -->
                <div>
                    <div class="flex flex-row items-end justify-between">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">Write
                            your review</label>
                        <p class="text-xs text-secondary">Public on {{creator()?.firstName}}'s profile.</p>
                    </div>
                    <div class="mt-2">
                        <textarea id="comment" name="comment" rows="4" [placeholder]="getCommentPlaceholder()" [disabled]="isSubmittingReview()"
                            [(ngModel)]="review" class="input-textarea text-primary disabled:opacity-60 disabled:cursor-not-allowed"></textarea>
                    </div>
                </div>
                <!-- Comment - END -->

            </div>
            <!-- Main Content - END -->

            <!-- Footer -->
            <div
                class="z-10 shrink-0 flex flex-row items-center justify-between w-full border-t border-zinc-200 dark:border-zinc-800 pt-2">
                <p class="text-sm text-secondary">Rate all four attributes to continue.</p>
                @if (isSubmittingReview()) {
                <span
                    class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                    <svg aria-hidden="true"
                        class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor" />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill" />
                    </svg>

                    Submitting Review...
                </span>
                } @else {
                <button type="button" class="inline-flex items-center gap-x-1.5 primary-button"
                    (click)="submitReview()">
                    Submit Review
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-mr-0.5 size-5">
                        <path
                            d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
                        <path d="m21.854 2.147-10.94 10.939" />
                    </svg>
                </button>
                }
            </div>
            <!-- Footer - END -->


            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>


    </div>
</div>